import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

interface Props {
    cc: ReturnType<typeof getCrmColors>;
    label: string;
    children: ReactNode;
}

/// Rótulo acima do select: o react-select não tem label flutuante e o placeholder some.
export const LabelledSelect = ({ cc, label, children }: Props) => (
    <Box>
        <Typography
            variant="caption"
            sx={{ color: cc.textSecondary, display: 'block', mb: 0.6, fontWeight: 600 }}
        >
            {label}
        </Typography>
        {children}
    </Box>
);
